import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class FontFamilyService {

  constructor(private apiClient: ApiClientService) {
  }

  getFonts(): Observable<string[]> {
    return new Observable<string[]>(subscriber => {
      this.apiClient.get('/font-family').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
